import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Play, User, Settings, Bell, Heart, Sparkles, DollarSign, Upload, Shield, Map } from 'lucide-react';

const sitemapSections = [
  {
    title: 'Pages Principales',
    icon: Home,
    links: [
      { label: 'Accueil', to: '/', description: 'Découvrez les vidéos tendances et nouvelles sorties' },
      { label: 'Pour vous', to: '/pour-vous', description: 'Recommandations personnalisées selon vos goûts' },
      { label: 'Favoris', to: '/favoris', description: 'Votre liste de vidéos sauvegardées' },
      { label: 'Adhésion', to: '/adhesion', description: 'Plans Gratuit, Premium et Créateur' },
      { label: 'Parrainage', to: '/referral', description: 'Invitez vos amis et gagnez des points' },
    ],
  },
  {
    title: 'Compte & Profil',
    icon: User,
    links: [
      { label: 'Connexion', to: '/login', description: 'Accédez à votre compte YetuTv' },
      { label: "S'inscrire", to: '/register', description: 'Créez votre compte gratuitement' },
      { label: 'Mon Profil', to: '/my-profile', description: 'Gérez vos informations personnelles' },
      { label: 'Paramètres', to: '/settings', description: 'Thème, notifications, confidentialité' },
      { label: 'Notifications', to: '/notifications', description: 'Vos alertes et actualités' },
    ],
  },
  {
    title: 'Espace Créateur',
    icon: Upload,
    links: [
      { label: 'Devenir Créateur', to: '/become-creator', description: 'Faites votre demande pour devenir créateur' },
      { label: 'Studio Créateur', to: '/creator/studio', description: 'Uploadez vos vidéos et suivez vos analytics' },
    ],
  },
  {
    title: 'Administration',
    icon: Shield,
    links: [
      { label: 'Panel Admin', to: '/admin', description: 'Gestion globale de la plateforme' },
      { label: 'Demandes Créateurs', to: '/admin/creator-requests', description: 'Approbation des demandes créateurs' },
    ],
  },
  {
    title: 'Contenu',
    icon: Play,
    links: [
      { label: 'Vidéos', to: '/', description: 'Parcourez tout le catalogue vidéo' },
      { label: 'Profils Acteurs', to: '/', description: "Découvrez les équipes derrière les productions" },
    ],
  },
];

export const SitemapPage = () => {
  return (
    <div className="min-h-screen bg-background pt-24 pb-12">
      <div className="container max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="mb-10">
          <div className="flex items-center gap-3 mb-3">
            <Map className="w-7 h-7 text-primary" />
            <h1 className="text-3xl font-bold text-foreground">Plan du site</h1>
          </div>
          <p className="text-muted-foreground text-base">
            Retrouvez toutes les pages disponibles sur YetuTv.
          </p>
        </div>

        {/* Sections */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {sitemapSections.map((section) => {
            const Icon = section.icon;
            return (
              <div
                key={section.title}
                className="bg-card border border-border rounded-xl p-6 space-y-4"
              >
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                    <Icon className="w-4 h-4 text-primary" />
                  </div>
                  <h2 className="text-base font-semibold text-foreground">{section.title}</h2>
                </div>
                <ul className="space-y-3">
                  {section.links.map((link) => (
                    <li key={link.to + link.label}>
                      <Link
                        to={link.to}
                        className="group flex flex-col gap-0.5 hover:bg-muted rounded-lg px-3 py-2 -mx-3 transition-colors"
                      >
                        <span className="text-sm font-medium text-foreground group-hover:text-primary transition-colors">
                          {link.label}
                        </span>
                        <span className="text-xs text-muted-foreground">{link.description}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        {/* Back link */}
        <div className="mt-10 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
          >
            <Home className="w-4 h-4" />
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SitemapPage;
